module.exports = __webpack_public_path__ + "img/logout-icon.f6cacd9f.svg";